import PropTypes from 'prop-types';
import { isNilOrEmpty, isObject } from 'ramda-extension';
import { useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { Dialog } from 'components';
import { getErrorsByPageName } from 'features/common/submitFormDialog/selectors';

export const SubmitFormDialog = ({ pageName }) => {
	const errors = useSelector((state) => getErrorsByPageName(state, pageName));

	return (
		!isNilOrEmpty(errors) && (
			<Dialog mui name={pageName}>
				{errors.map((errorField) => (
					<div key={errorField}>
						{isObject(errorField)
							? getLabelMessage(`submitFormDialog:${errorField?.name}`, { ...errorField?.params })
							: getLabelMessage(`submitFormDialog:${errorField}`)}
					</div>
				))}
			</Dialog>
		)
	);
};

SubmitFormDialog.propTypes = {
	pageName: PropTypes.string,
};

export default SubmitFormDialog;
